import {ChevronDown, Mail, Send} from 'lucide-react'
import { useState } from 'react'

function Footer() {
  const [showContacts, setShowContacts] = useState(false)

  return (
    <footer className="border-t border-neutral-800 bg-neutral-950 py-10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 sm:flex-row sm:px-6 lg:px-8">
        <div className="text-lg font-black tracking-tight text-white">
          SEO<span className="text-emerald-400">/</span>GEO
        </div>

        <div className="flex flex-col items-center gap-3">
          <button
            type="button"
            onClick={() => setShowContacts(prev => !prev)}
            className="flex items-center gap-1.5 text-sm font-medium text-neutral-400 transition-colors hover:text-white"
          >
            {showContacts ? 'Скрыть контакты' : 'Показать контакты'}
            <ChevronDown className={`h-4 w-4 transition-transform ${showContacts ? 'rotate-180' : ''}`} />
          </button>

          {showContacts
            ? (
                <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-6">
                  <a
                    href="mailto:vn@nygma.io"
                    className="flex items-center gap-1.5 text-sm text-neutral-400 transition-colors hover:text-white"
                  >
                    <Mail className="h-4 w-4" />
                    vn@nygma.io
                  </a>
                  <a
                    href="https://t.me/slavique"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1.5 text-sm text-neutral-400 transition-colors hover:text-white"
                  >
                    <Send className="h-4 w-4" />
                    @slavique
                  </a>
                </div>
              )
            : null}
        </div>

        <p className="text-xs text-neutral-600">
          © {new Date().getFullYear()}. Все права защищены.
        </p>
      </div>
    </footer>
  )
}

export default Footer
